"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgDeviceSensor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.91 33.51l-.086-.31c-2.558-8.881-11.77-14.112-20.734-11.71l.517 1.932.304-.079c7.906-1.945 15.95 2.785 18.067 10.685l1.932-.517zm-6.971.917l.072.255-1.931.518a7 7 0 00-8.34-5.008l-.234.058-.517-1.932a9 9 0 0110.95 6.109zM74 35a7 7 0 016.996 6.76L81 42v46a7 7 0 01-6.76 6.996L74 95H36a7 7 0 01-6.996-6.76L29 88V42a7 7 0 016.76-6.996L36 35h38zm0 2H36a5 5 0 00-4.995 4.783L31 42v46a5 5 0 004.783 4.996L36 93h38a5 5 0 004.995-4.783L79 88V42a5 5 0 00-5-5zm-6 46v-2H42v2h26zm0-9v2H42v-2h26zm0-5v-2H42v2h26z",
    fill: props.color || "#133251"
  }));
}

var _default = SvgDeviceSensor;
exports["default"] = _default;